import React, { useEffect, useState } from "react";
import { LogOut, RotateCcw, User } from "feather-icons-react/build/IconComponents";
import { BiRestaurant } from "react-icons/bi";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import PropTypes from "prop-types";
import { base_api_url } from "../../../environment.jsx";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const CuisineHeader = ({ onRefresh, loading, selectedEtiquette, onEtiquetteChange }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const [Etiquettes, setEtiquettes] = useState([]);

  const cuisinier = JSON.parse(localStorage.getItem("cuisinier_actif") || "{}");

  const handleLogout = () => {
    MySwal.fire({
      // title: "Déconnexion",
      html: '<div style="text-align: center;">Êtes-vous sûr de vouloir vous déconnecter ?</div>',
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Oui, se déconnecter",
      cancelButtonText: "Annuler"
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("cuisinier_actif");
        navigate("/signin");
      }
    });
  };

  useEffect(() => {
    fetchEtiquettes();
  }, []);

  const fetchEtiquettes = async () => {
    const ideresto = JSON.parse(localStorage.getItem("cuisinier_actif"))?.id_restaurant;
    const token = JSON.parse(localStorage.getItem("user"))?.access_token;

    try {
      const response = await axios.get(`${base_api_url}api/etiquette/${ideresto}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setEtiquettes(response.data.etiquette || []); // stocker toutes les étiquettes
      console.log("Étiquettes chargées :", response.data.etiquette);
    } catch (error) {
      console.error("Error fetching etiquettes:", error);

      //             let errorTitle = "Erreur de chargement des étiquettes";
      let errorMessage = "Impossible de charger les étiquettes.";

      if (error.response) {
        const status = error.response.status;
        const errorData = error.response.data;

        switch (status) {
          case 401:
            //                         errorTitle = "Session expirée";
            errorMessage = "Votre session a expiré. Veuillez vous reconnecter.";
            break;

          case 404:
            //                         errorTitle = "Étiquettes introuvables";
            errorMessage = "Aucune étiquette trouvée pour ce restaurant.";
            break;

          case 500:
            //                         errorTitle = "Erreur du serveur";
            errorMessage = "Une erreur s'est produite sur le serveur lors du chargement des étiquettes.";
            break;

          default:
            //                         errorTitle = `Erreur ${status}`;
            errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des étiquettes.";
        }
      } else if (error.request) {
        //                 errorTitle = "Problème de connexion";
        errorMessage = "Impossible de contacter le serveur pour charger les étiquettes.";
      }

      // Show error toast
      MySwal.fire({
        icon: "error",
        // title: errorTitle,
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });

      // Set empty array on error
      setEtiquettes([]);
    }
  };

  return (
    <div className="bg-white shadow-sm border-bottom px-4 py-3">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <BiRestaurant size={28} className="text-primary me-3" />
          <div>
            <h4 className="mb-0">Interface de préparation</h4>
            <small className="text-muted">Gestion des commandes</small>
          </div>
        </div>
        <div className="d-flex align-items-center gap-3">
          <select
            name="etiquette"
            className="form-control"
            value={cuisinier.etiquette || selectedEtiquette}
            onChange={(e) => onEtiquetteChange(e.target.value)}
            disabled={!!cuisinier.etiquette}
            title={cuisinier.etiquette ? "Votre pôle est assigné par l'administrateur" : "Filtrez par pôle"}
            style={{ backgroundColor: cuisinier.etiquette ? '#e9ecef' : 'white', cursor: cuisinier.etiquette ? 'not-allowed' : 'pointer'}}
          >
            <option value="">
              {Etiquettes.length === 0 ? "Aucune étiquette disponible" : "Toutes les étiquettes"}
            </option>
            {Etiquettes.map((etiq) => (
              <option key={etiq.id_etiquette} value={etiq.code}>
                {etiq.nom || etiq.code}
              </option>
            ))}
          </select>

          <button
            className="btn btn-outline-primary"
            onClick={onRefresh}
            disabled={loading}
            title="Actualiser les commandes"
          >
            <RotateCcw size={16} className={loading ? "spin" : ""} />
            <span className="d-none d-md-inline ms-2">Actualiser</span>
          </button>

          <div className="dropdown">
            <button
              className="btn btn-outline-secondary d-flex align-items-center"
              onClick={() => setShowUserMenu(!showUserMenu)}
              aria-expanded={showUserMenu}
            >
              <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-2"
                style={{ width: '32px', height: '32px', fontSize: '14px', color: 'white' }}>
                {cuisinier.nom_cuisinier?.charAt(0).toUpperCase() || 'C'}
              </div>
              <div className="d-flex flex-column align-items-start">
                <span className="d-none d-md-inline fw-semibold" style={{ lineHeight: '1.2' }}>
                  {cuisinier.nom_cuisinier || 'Cuisinier'}
                </span>
                {cuisinier.email && (
                  <small className="d-none d-md-inline text-muted" style={{ fontSize: '10px' }}>
                    {cuisinier.email}
                  </small>
                )}
              </div>
            </button>

            {showUserMenu && (
              <div className="dropdown-menu dropdown-menu-end show" style={{ position: 'absolute', right: 0, top: '100%' }}>
                <div className="dropdown-header">
                  <div className="d-flex align-items-center">
                    <User size={16} className="me-2" />
                    <div>
                      <div className="fw-semibold">{cuisinier.nom_cuisinier}</div>
                      <small className="text-muted">Nom et prénom: {cuisinier.nom_cuisinier}</small>
                    </div>
                  </div>
                </div>
                <div className="dropdown-divider"></div>
                <button className="dropdown-item text-danger" onClick={handleLogout}>
                  <LogOut size={16} className="me-2" />
                  Se déconnecter
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

CuisineHeader.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  selectedEtiquette: PropTypes.string,
  onEtiquetteChange: PropTypes.func.isRequired,
};

export default CuisineHeader;